export default [
  'M20 1.7C9.9 1.7 1.8 9.9 1.8 20S9.9 38.3 20 38.3 38.2 30.1 38.2 20 30.1 1.7 20 1.7zm0 34.1c-8.7 0-15.8-7.1-15.8-15.9S11.3 4.1 20 4.1 35.8 11.2 35.8 20 28.7 35.8 20 35.8z',
  'M21.2 19.5V9c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v11c0 .2 0 .3.1.5s.2.3.3.4l7.3 7.3c.2.2.5.4.9.4.3 0 .6-.1.9-.4.5-.5.5-1.2 0-1.7l-7.1-7z',
];
